import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';

import { CustomTypography } from '../../common/CustomTypoGraphy';
import { useQuery } from '../../common/Utils';
import userService from '../../api/UserService';
import { callFetchData } from '../../common/Fetch';
import getI18nService from '../../i18n/i18n';

const i18n = getI18nService();

export default function Sso(props) {
  const theme = useTheme();
  let query = useQuery();
  const sessionId = query.get('sessionId');
  const essid = query.get('essid');
  const mac = query.get('mac');
  const ip = query.get('ip');
  const forward = query.get('forward');

  const handleSelfOnboardingForGuest = async () => {
    console.log('Craft SSO url and send the user for login!');
    if (sessionId && mac) {
      const api = Object.assign({}, userService.CreateSsoLoginSessionForGuest, {
        data: { sessionId },
        params: { essid, forward, mac, ip },
      });
      const response = await callFetchData(api);
      let resp = {};
      if (response && response.status === 200) {
        resp = response.resp;
        if (resp && resp.url) {
          window.location.href = resp.url;
        }
      }
    }
  };

  return (
    <Box
      sx={{
        my: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          my: 2,
          mx: 2,
        }}
      >
        <Divider
          sx={{
            flexGrow: 1,
            borderColor: 'text.disabled',
          }}
        />
        <CustomTypography
          sx={{
            mx: 2,
            color: 'text.disabled',
            fontSize: '14px',
          }}
        >
          OR
        </CustomTypography>
        <Divider
          sx={{
            flexGrow: 1,
            borderColor: 'text.disabled',
          }}
        />
      </Box>
      <Box>
        <CustomTypography
          onClick={handleSelfOnboardingForGuest}
          sx={{ textAlign: 'center', fontSize: '14px', color: 'primary.main', cursor: 'pointer' }}
        >
          {i18n.t('Vocabulary.sso')}
        </CustomTypography>
      </Box>
    </Box>
  );
}
